import React from 'react';
import { useSpring, animated } from 'react-spring';

const Zoom = ({ children, open = true, ...properties }) => {
	const scaleLevel = 0.99;
	const trans = (s) => `scale(${s})`;
	const [props, set] = useSpring(() => ({
		s: scaleLevel,
		config: { mass: 5, tension: 350, friction: 40 },
	}));
	return (
		<animated.span
			onMouseMove={() => set({ s: 1 })}
			onMouseLeave={() => set({ s: scaleLevel })}
			style={{}}
			{...properties}
		>
			{children}
		</animated.span>
	);
};

export default Zoom;
